<template>
  <div>
    <!-- MENSAJE DE CONFIRMACIÓN -->
    <mensajeSistema></mensajeSistema>

    <!-- FILTROS DE NIVEL, PERIODO, GRADO, SECCIÓN, ÁREA, CURSO -->
    <v-row class="pl-1">
      <v-col cols="12" sm="" class="pt-0">
        <v-select label="Nivel" v-model="filter.id_nivel" @change="EventNivel(filter.id_nivel)" :items="listNivel"
          item-value="id" item-text="desc_nivel">
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select label="Periodo" v-model="filter.id_periodo" @change="EventPeriodo(filter.id_periodo, filter.id_curso)"
          :items="listPeriodo" item-value="id" item-text="nombre_periodo">
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select label="Grado" v-model="filter.id_grado" @change="EventGrado(filter.id_grado)" :items="listGrado"
          item-value="id" item-text="desc_grado">
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select label="Sección" v-model="filter.id_seccion" @change="EventSeccion(filter.id_seccion, filter.id_curso)"
          :items="listSeccion" item-value="id" item-text="desc_seccion">
        </v-select>
      </v-col>

      <v-col cols="12" sm="" class="pt-0">
        <v-select label="Área" v-model="filter.id_area" @change="EventArea(filter.id_area)" :items="listArea"
          item-value="id" item-text="desc_area">
        </v-select>
      </v-col>

      <v-col cols="12" sm="4" md="" class="py-0">
        <v-select label="Curso:" v-model="filter.id_curso" @change="EventCurso(filter.id_curso)" :items="listCurso"
          item-value="id" item-text="desc_curso">
        </v-select>
      </v-col>
    </v-row>

    <!-- BOTÓN PARA VISUALIZAR EL NOMBRE DEL DOCENTE Y BOTÓN AÑADIR COMENTARIO-->
    <v-row class="pl-1 pb-1">
      <v-col cols="12" sm="12" class="pt-0 pr-4 d-flex justify-space-between">
        <v-chip small class="color_activo">
          Docente: {{ docente.apellido_nombre }}</v-chip>
      </v-col>
    </v-row>

    <!-- TABLA (VERSION MEJORADA) -->
    <ag-grid-vue v-if="isDataLoaded" style="width: 100%; height: 650px;"
      class="ag-theme-balham estilo-personalizado-vue-grid" :columnDefs="columnasDinamicas"
      :enableBrowserTooltips="true" :rowData="dataNew" @cell-clicked="verObservacion"
      @cell-value-changed="EditarNotas($event)">
    </ag-grid-vue>

    <!-- MODAL DE OBSERVACIÓN DEL ESTUDIANTE-->
    <v-dialog v-model="modalObservacion" persistent scrollable max-width="600px">
      <v-card>
        <v-card-title class="modal_title py-5 mb-2">
          <v-row class="d-flex justify-space-between py-0">
            Observación
            <v-spacer></v-spacer>
            <v-btn fab dark x-small class="btn_style3" @click="modalObservacion = false">
              <v-icon dark>fa-times</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-textarea v-model="observacionEstudianteMostrar"></v-textarea>
              <v-btn :style="{ color: '#ffffff' }" class="btn_block_style2"
                @click="SaveObservationStudent(observacionEstudianteMostrar)">Guardar</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
// import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import { AgGridVue } from 'ag-grid-vue';

export default {
  components: { AgGridVue },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    datoLogin: sessionStorage,
    currentPeriods: sessionStorage.periodos_actuales,
    test: true,

    selectedEvaluacion: null,
    //Columnas dinamicas del header y el row del data
    columnasDinamicas: [],
    dataNew: [],

    isDataLoaded: false,
    filter: {},
    listPeriodo: [],
    listNivel: [],
    listGrado: [],
    listSeccion: [],
    listArea: [],
    listCurso: [],
    docente: {},
    estudianteSeleccionadoCelda: null,
    observacion: "",
    observacionEstudianteMostrar: "",
    permisoMantenimiento: null, //Este es el objeto que viene desde lo configurado en  Mantenimiento
    permisoPeriodoActual: false, //Este solo permite actualizar el periodo actual
    permisoHabilitadoCierreNotas: false, //Este representa si se le habilito algun periodo en especifico
    permisoGeneral: false, //Este representa el determinara si se edita o no

    modalObservacion: false,
    listAlumno: [],
    listAlumnoComentarios: [],



    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      selectReq2: (value) =>
        (value || "").length > 0 || "Debe seleccionar un campo de la lista",

      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },

    datosColegio: {
      id: 0,
      id_ubicacion1: null,
      id_ubicacion2: null,
      id_ubicacion3: null,
      ruc_colegio: "",
      resolucion_colegio: "",
      nombre_colegio: "",
      logo_colegio: "",
      web_colegio: "",
      correo_colegio: "",
      fec_constitucion: "",
      responsable_nombre: "",
      responsable_telf: "",
      responsable_correo: "",
      direc_colegio: "",
      telf_colegio: "",
      estado_colegio: 1,
      id_usuario: 0,
      es_sucursal: 0,
      cambio_notas: true,
      parent_id_colegio: null,
    },
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    studentColumn() {
      return [
        { headerName: "Nombres y Apellidos", field: "nombre_apellido", pinned: 'left', width: 150 },
        { headerName: "Número de documento", field: "numdoc_persona", pinned: 'left', width: 100, headerTooltip: `Número de documento` },
        { headerName: "Observación", pinned: 'left', width: 130, minWidth: 20, cellRenderer: this.iconoObservacion }
      ]
    }
  },

  mounted() {
    this.LoadMain();
    this.getColegio();
    this.getPermissionProfessor();
  },

  created() {
    this.ActualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    ActualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    /** 
    _________________________
    |  PETICIONES AL BACK  */
    async LoadMain() {
      this.LimpiarFiltrado('todo');

      await this.GetUserDocente(this.datoLogin.id);



      this.GetNivel(this.datoLogin.id_ano_lectivo, this.filter.id_docente);

    },

    async LoadDataReporte(filter) {
      let params = {
        id_colegio: filter.id_colegio,
        id_ano_lectivo: filter.id_ano_lectivo,
        id_periodo: filter.id_periodo,
        id_seccion: filter.id_seccion,
        id_area: filter.id_area,
        id_curso: filter.id_curso,
        id_docente: filter.id_docente,
        id_usuario: filter.id_usuario,
      };


      console.log('params', params);

      try {
        let response = await axios.post(
          `/evaluacion/reporte/registroAuxiliar/`,
          { filter: params }
        );

        console.log('response', response);

        //HEADER
        this.columnasDinamicas = this.createColumnCompNivelLogro(response.data.Header);

        //DATA
        this.dataNew = response.data.dataStudentNotes;
        this.processStudentData();

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetUserDocente(id_usuario) {
      try {
        let { data } = await axios.get(
          `/sistema/integral/getUsuarioPersonal/${id_usuario}`
        );

        if (typeof data === 'object' && data !== null) {
          this.filter.id_docente = data.id_personal;
          this.docente = data;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `El usuario no es un docente`,
            tiempo: 8000,
          });
          this.docente = {};
          this.filter.id_docente = null;
        }


        console.log('respon', data);


      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getColegio() {
      try {
        let response = await axios.get(
          "/administrativo/colegio/" + this.datoLogin.id_colegio
        );
        this.datosColegio = await response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetPeriodo(id_colegio, id_ano_lectivo, id_nivel) {
      let params = { id_colegio, id_ano_lectivo, id_nivel };
      try {
        let response = await axios.post(`/sistema/integral/getPeriodo/`, {
          filter: params,
        });
        this.listPeriodo = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //Permisos docente (se habilita desde mantenimiento)
    async getPermissionProfessor() {
      try {
        const response = await axios.get(`/administrativo/cierrenotas/getDocentePermiso/${this.datoLogin.id_persona}`)

        this.permisoMantenimiento = response.data;
      } catch (error) {
        console.error(error);

      }
    },

    async GetNivel(id_ano_lectivo, id_docente) {

      let params = {
        id_ano_lectivo,
        id_docente,
        id_colegio: sessionStorage.id_colegio,
      };


      console.log({ params });


      try {
        let response = await axios.post(`/sistema/integral/getNivelDoc/`, {
          filter: params,
        });

        console.log({ response });


        this.listNivel = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetGrado(id_colegio, id_docente, id_nivel) {
      let params = { id_colegio, id_docente, id_nivel, id_ano_lectivo: this.datoLogin.id_ano_lectivo };
      try {
        let response = await axios.post(`/sistema/integral/getGradoDoc/`, {
          filter: params,
        });
        this.listGrado = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetArea(id_colegio, id_docente, id_grado) {
      let params = { id_colegio, id_docente, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getAreaDoc/`, {
          filter: params,
        });
        this.listArea = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetSeccion(id_colegio, id_docente, id_grado) {
      let params = { id_colegio, id_docente, id_grado };
      try {
        let response = await axios.post(`/sistema/integral/getSeccionDoc/`, {
          filter: params,
        });
        this.listSeccion = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetCurso(id_colegio, id_docente, id_grado, id_area) {
      let params = { id_colegio, id_docente, id_grado, id_area };
      try {
        let response = await axios.post(`/sistema/integral/getCursoDoc/`, {
          filter: params,
        });
        this.listCurso = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //EDITAR NOTAS
    async EditarNotas(event) {
      let modificacion_nota_celda = event.data[event.colDef.field].toLowerCase();

      //1.- VALIDACIONES PARA ACEPTAR VALORES CORRECTOS EN LITERAL || NUMERICO
      if (event.data.all_evals_con_sus_desempenios[0].f4 == 'L') {

        if (modificacion_nota_celda.trim() != 'ad' && modificacion_nota_celda.trim() != 'a' && modificacion_nota_celda.trim() != 'b' && modificacion_nota_celda.trim() != 'c') {
          this.setEnviarMens({
            tipo: 'W',
            mensaje: 'La evaluación es literal y solo esta permitido colocar AD, A ,B o C.'
          })
          return
        }

        //1.1.- ACTUALIZAR LA NOTA DEL NIVEL DE LOGRO POR COMPETENCIA
        if (event.colDef.headerName == 'Nivel de logro') {

          let id_competencia = event.colDef.field.split('_')[3];

          let id_nivel_logro = Object.keys(event.data).find((clave) => {
            return event.data[clave] == id_competencia;
          });

          id_nivel_logro = id_nivel_logro.split('_')[3];

          let nota_actualizada = this.switchNoteToDatabase(event.newValue.toLowerCase(), event.data.all_evals_con_sus_desempenios[0].f4)

          let params = { id_nivel_logro, nota_actualizada };

          const response = await axios.put("/evaluacion/reporte/registroAuxiliarEditarNivelLogro", params);

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
          });

          //1.1.- ACTUALIZAR LA NOTA DE LOS INDICADORES DE LA EVALUACIÓN
        } else {
          let id_alumno = event.data.id_alumno;
          let id_evaluacion = event.colDef.field.split('_')[2];
          let id_indicador = event.colDef.field.split('_')[4];
          let nota_actualizada = this.switchNoteToDatabase(event.data[event.colDef.field].toLowerCase(), event.data.all_evals_con_sus_desempenios[0].f4);

          let params = { id_alumno, id_evaluacion, id_indicador, nota_actualizada };

          const response = await axios.put("/evaluacion/reporte/registroAuxiliarEditarDesempenioEvaluacion", params);

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
          });
        }

      } else if (event.data.all_evals_con_sus_desempenios[0].f4 == 'N') {
        console.log('Aqui ira la logica cuando sea una evalaucion numerica')
      }

      //2.- Volvemos a llamar a los estudiantes para tener los promedios actualizados
      this.LoadDataReporte(this.filter);

    },

    async EditComentStudent(filter) {

      try {
        let params = {
          id_ano_lectivo: filter.id_ano_lectivo,
          id_colegio: filter.id_colegio,
          id_seccion: filter.id_seccion,
        };
        let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
          filter: params,
        });

        this.listAlumno = response.data;
        this.listAlumnoComentarios = response.data.result;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async SaveObservationStudent(comentario) {
      try {

        let filter = {
          id_alumno: this.estudianteSeleccionadoCelda.data.id_alumno,
          id_ano_lectivo: this.estudianteSeleccionadoCelda.data.id_ano_lectivo,
          id_area: this.estudianteSeleccionadoCelda.data.id_area,
          id_colegio: this.estudianteSeleccionadoCelda.data.id_colegio,
          id_periodo: this.estudianteSeleccionadoCelda.data.id_periodo,
          id_seccion: this.estudianteSeleccionadoCelda.data.id_seccion,
          observacion: comentario
        }

        let params = {
          filter,
          id_usuario: this.datoLogin.id,
        };
        let res = "";

        res = await axios.post(
          "/evaluacion/reporte/SaveObservacionAreaAlumno",
          params
        );

        this.LoadDataReporte(this.filter);

        this.setEnviarMens({
          tipo: res.data.messageT,
          mensaje: res.data.message,
          tiempo: null,
        });

        this.modalObservacion = false;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }

    },

    /** 
    _______________________________________
    |  DISPARADORES Y FUNCIONES DE APOYO */
    EventNivel(id_nivel) {
      this.LimpiarFiltrado('nivel');

      this.GetPeriodo(
        this.datoLogin.id_colegio,
        this.datoLogin.id_ano_lectivo,
        id_nivel
      );
      this.GetGrado(
        this.datoLogin.id_colegio,
        this.filter.id_docente,
        id_nivel
      );
    },

    allowAccessOrNo() {
      let contiene = this.permisoMantenimiento.filter((e) => {
        return e.id_periodo == this.filter.id_periodo && e.id_curso_adm == this.filter.id_curso
      });

      this.permisoHabilitadoCierreNotas = contiene.some((e) => {
        return e.id_curso_adm == this.filter.id_curso
      });

      this.permisoGeneral = this.permisoHabilitadoCierreNotas;

    },

    EventPeriodo(id_periodo, id_curso) {


      console.log(id_periodo, id_curso);


      let periodosArray = this.currentPeriods.split(',').map(Number);
      this.permisoPeriodoActual = periodosArray.includes(id_periodo)

      // if(this.permisoMantenimiento.length){
      //   console.log(id_periodo, this.permisoMantenimiento[0].id_periodo)
      //   if(id_periodo == this.permisoMantenimiento[0].id_periodo){
      //     this.permisoHabilitadoCierreNotas = true; 
      //   };
      // };

      // if(this.permisoPeriodoActual){ //Aqui solo entrara cuando sea el periodo actual
      //   this.permisoGeneral = true;
      // }else if(this.permisoHabilitadoCierreNotas) { //Aqui cuando se haya habilitado el webmaster
      //   this.permisoGeneral = true;
      // }else {
      //   console.log('Entro en el ultimo else ')
      //   this.permisoGeneral = false;
      // }

      if (id_curso == "" || id_curso == undefined) {
        return false;
      }

      this.EventCurso(id_curso); //ESTO LO QUITARE CREO
    },

    EventGrado(id_grado) {
      this.LimpiarFiltrado('grado');

      this.GetArea(this.datoLogin.id_colegio, this.filter.id_docente, id_grado);
      this.GetSeccion(
        this.datoLogin.id_colegio,
        this.filter.id_docente,
        id_grado
      );
    },

    EventSeccion(id_seccion, id_curso) {

      if (id_curso == "" || id_curso == undefined) {
        return false;
      }

      this.LoadDataReporte(this.filter);
    },

    EventArea(id_area) {
      this.filter.id_curso = "";

      this.GetCurso(
        this.filter.id_colegio,
        this.filter.id_docente,
        this.filter.id_grado,
        id_area
      );
    },

    EventCurso(id_curso) {

      if (id_curso == "" || id_curso == undefined) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar una Sección `,
          tiempo: 5000,
        });

        return false;
      }

      //Aca debe estar mi condicional de que en caso el docente no tenga autorización, aun asi no se el muestre el botón
      this.LoadDataReporte(this.filter);
      this.allowAccessOrNo();
    },

    //-- PROCESAR EL DINAMISCO EN EL HEADER, CON EL NIVEL DE LOGRO POR COMPETENCIAS
    createColumnCompNivelLogro(dataHeader) {
      const competencias = Object.values(dataHeader).map(comp => {
        const evaluaciones = comp.evaluaciones.map(e => {
          const capacidades = Object.values(e.capacidades).map(cap => {
            const desempenios = cap.desempenos.map(des => {
              return {
                headerName: `Desempeño: ${des.nombre_desempeno}`,
                field: `id_eval_${e.id_evaluacion}_indicador_${des.id_desempeno}`,
                headerTooltip: `${des.nombre_desempeno}`,
                cellStyle: this.getCellStyle,
                width: 150,
                //editable: this.permisoGeneral,
                editable: true,
              }
            })

            return {
              headerName: `Capacidad: ${cap.nombre_capacidad}`,
              field: `id_competencia_${cap.id_capacidad}`,
              headerTooltip: `${cap.nombre_capacidad}`,
              width: 150,
              children: desempenios
            }
          })

          return {
            headerName: `Nombre evaluación: ${e.nombre_evaluacion}`,
            headerTooltip: `${e.nombre_evaluacion}`,
            children: [...capacidades,
            {
              headerName: `Promedio de la evaluación`,
              field: `promedio_eval_${e.id_evaluacion}`,
              width: 185, cellStyle: this.getCellStyle,
              headerTooltip: `Promedio de la evaluación`
            }
            ],
          }
        })

        return {
          headerName: `Competencia: ${comp.nombre_competencia}`, headerTooltip: `${comp.nombre_competencia}`,
          children: [...evaluaciones,
          {
            headerName: `Nivel de logro`,
            field: `nivel_logro_comp_${comp.id_competencia}`,
            headerTooltip: `Nivel de logro`,
            width: 110,
            cellStyle: this.getCellStyle,
            //editable: this.permisoGeneral,
            editable: true,
          }]
        }
      });

      return this.studentColumn.concat(competencias);
    },

    //-- PROCESA LA CORRECTA ASIGNACIÓN DE LAS NOTAS DE LOS ESTUDIANTES CON SUS INDICADORES
    processStudentData() {
      //  https://gist.github.com/sebastiangs23/e331e0cd297264df2b63bff185572807

      this.dataNew = this.dataNew.map(student => {
        const newStudent = { ...student };
        let num_o_lit;

        student.all_evals_con_sus_desempenios.forEach(evalua => {
          let numerica_o_literal = evalua.f4;

          //--> RENDERIZADO CLIENTE (INDICADORES)
          let nota_redondeada_indicador = this.redondearPersonalizado(evalua.f9);
          let NOTA_PRACTICA_ADABC_123 = this.switchLiteralNumerico(nota_redondeada_indicador, numerica_o_literal);

          //--> RENDERIZADO CLIENTE (EVALUACIÓN)
          let nota_redondeada_evaluacion = this.redondearPersonalizado(evalua.f3)
          let NOTA_PROM_PRACTICA_ADABC_123 = this.switchLiteralNumerico(nota_redondeada_evaluacion, numerica_o_literal);

          //--> ESTOS CAMPOS DEBEN COINCIDIR CON EL FIELD DEL HEADER
          newStudent[`id_eval_${evalua.f1}_indicador_${evalua.f7}`] = NOTA_PRACTICA_ADABC_123;
          newStudent[`promedio_eval_${evalua.f1}`] = NOTA_PROM_PRACTICA_ADABC_123;

          num_o_lit = numerica_o_literal;
        });

        //--> RENDERIZADO CLIENTE (NIVEL DE LOGRO)
        student.nivel_de_logro.forEach(n => {
          let nivel_logro_redondeado = this.redondearPersonalizado(n.f4);
          let NOTA_NIVEL_LOGRO_ADABC_123 = this.switchLiteralNumerico(nivel_logro_redondeado, num_o_lit);

          newStudent[`nivel_logro_comp_${n.f2}`] = NOTA_NIVEL_LOGRO_ADABC_123;
          newStudent[`id_nivel_logro_${n.f1}`] = n.f2;
        });

        return newStudent;
      });

      this.isDataLoaded = true;
    },

    getCellStyle(params) {
      let color = null;

      let nota = params.value;
      switch (nota) {
        case 'AD': {
          color = '#008000'
          break;
        }
        case 'A': {
          color = '#0000ff'
          break;
        }
        case 'B': {
          color = '#a52a2a'
          break;
        }
        case 'C': {
          color = '#ff0000'
          break;
        }
      }
      return { color: color };
    },

    iconoObservacion(e) {
      let color = ``;

      e.data.observacion == null || e.data.observacion == '' ? color = `#B0B0B0` : color = `#0ABEC7`

      return `<i class="fas fa-comment"
            style="color: ${color}; font-size: 24px; display: flex; align-items: center; justify-content: center;"></i>`
    },

    verObservacion(event) {
      this.estudianteSeleccionadoCelda = event;

      //Solo abre el modal cuando se seleccione la celda correcta
      if (event.event.target.classList.contains('fa-comment')) {
        this.modalObservacion = true;
        this.observacionEstudianteMostrar = event.data.observacion;
      }
    },

    redondearPersonalizado(numero) {
      if (numero == null) {
        return numero;
      } else {
        const parteDecimal = numero % 1;
        if (parteDecimal <= 0.49) {
          return Math.floor(numero)
        } else if (parteDecimal >= 0.5) {
          return Math.ceil(numero)
        }
      }

    },

    switchLiteralNumerico(nota_redondeada, numerica_o_literal) {
      let NOTA_ADABC_123;

      if (numerica_o_literal == 'L' || numerica_o_literal == undefined) {
        switch (nota_redondeada) {
          case 1: {
            NOTA_ADABC_123 = 'C'
            break;
          }
          case 2: {
            NOTA_ADABC_123 = 'B'
            break;
          }
          case 3: {
            NOTA_ADABC_123 = 'A'
            break;
          }
          case 4: {
            NOTA_ADABC_123 = 'AD'
            break;
          }
          default: {
            NOTA_ADABC_123 = '-'
          }
        }
        return NOTA_ADABC_123;
      } else if (numerica_o_literal == 'N') {
        //Aca nose si sea necesario una logica para las notas numericas
      }
    },

    switchNoteToDatabase(nota, numerica_o_literal) {
      let NOTA_123;
      if (numerica_o_literal == 'L' || numerica_o_literal == undefined) {
        switch (nota) {
          case 'ad': {
            NOTA_123 = 4;
            break;
          }
          case 'a': {
            NOTA_123 = 3;
            break;
          }
          case 'b': {
            NOTA_123 = 2;
            break;
          }
          case 'c': {
            NOTA_123 = 1;
            break;
          }
        }
      } else if (numerica_o_literal == 'N' || numerica_o_literal == undefined) {
        //Aca nose si sea necesario una logica para las notas numericas 
      }

      return NOTA_123;
    },

    LimpiarFiltrado(select) {
      switch (select) {

        case 'nivel': {
          this.filter.id_grado = "";
          this.filter.id_area = "";
          this.filter.id_seccion = "";
          this.filter.id_curso = "";
          this.listSeccion = [];
          this.listArea = [];
          this.listCurso = [];
          break;
        }

        case 'grado': {
          this.filter.id_seccion = "";
          this.filter.id_area = "";
          this.filter.id_curso = "";
          this.listSeccion = [];
          this.listCurso = [];
          this.columnasDinamicas = [];
          this.dataNew = [];
          break;
        }

        case 'todo': {
          this.filter = {
            id_colegio: this.datoLogin.id_colegio,
            id_ano_lectivo: this.datoLogin.id_ano_lectivo,
            id_periodo: "",
            id_nivel: "",
            id_grado: "",
            id_area: "",
            id_seccion: "",
            id_curso: "",
            id_docente: "",
            id_usuario: this.datoLogin.id,
          };

          break;
        }
      }
    }
  },
};
</script>

<style scoped>
.Table {
  display: table;
}

.Title {
  display: table-caption;
  text-align: center;
  font-weight: bold;
  font-size: larger;
}

.Heading {
  display: table-row;
  font-weight: bold;
  text-align: center;
}

.Row {
  display: table-row;
}

.Cell {
  display: table-cell;
  border: solid;
  border-width: thin;

}

.Cell2 {
  display: table-cell;
  border: solid;
  border-width: thin;
  padding-left: 5px;
  padding-right: 5px;
}

.red-text {
  color: red;
}

.colored-text-field /deep/ .v-input__control input {
  color: inherit;
}


.clickeable-row {
  cursor: pointer;
}

.estilo-personalizado-vue-grid {
  --ag-foreground-color: rgb(51, 51, 51);
  --ag-odd-row-background-color: rgb(238, 249, 254);
  --ag-header-foreground-color: rgb(182, 221, 246);
  --ag-header-background-color: #1565c0;

  --ag-border-color: rgb(220, 220, 220);
  --ag-header-border-color: rgb(192, 192, 192);
  --ag-font-family: 'Arial, sans-serif';
  --ag-font-size: 14px;
}
</style>
